import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import DetailToolBar from '../fw/DetailToolBar.react.js';
import DetailBox from '../fw/DetailBox.react.js';
import TableDetail from '../fw/TableDetail.react';
import DeleteButton from '../fw/DeleteButton.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'billingRuleView.title', 'defaultMessage': 'Billing rule'}
});

interface BillingRuleViewProps {
    intl: IntlShape;
    user: User;
}

class BillingRuleView extends React.Component<BillingRuleViewProps> {

    typeName = 'billingRules';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        const data = this.props.user.organisation.billingRule;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <DetailBox data={data} metadata={type} urlMapping={urlMapping}>
                    <DetailToolBar data={data} metadata={type} organisationId={this.props.user.organisation.realId} urlMapping={urlMapping}>
                        <DeleteButton
                            data={data}
                            deleteFatQuery={Relay.QL `fragment on DeleteBillingRulePayload {
                                                            updatedNode {
                                                                id
                                                            },
                                                            organisation {
                                                                billingRules(first: 2000) {
                                                                    edges {
                                                                        node {
                                                                            id
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                        }`}
                            deleteMutation={Relay.QL `mutation { deleteBillingRule }`}
                            metadata={type}
                            organisationId={this.props.user.organisation.realId}
                            types={types}
                            urlMapping={urlMapping}
                        />
                    </DetailToolBar>

                    <h2>{data.name}</h2>

                    <TableDetail columns={{
                        'flowDef.name': {},
                        'flow.flowTitle': {},
                        'billingNote': {},
                        'validSince': {},
                        'validTo': {},
                        'overridePricePerInstance': {},
                        'overridePricePerInstanceNext': {},
                        'overridePricePerInvocation': {},
                        'overrideTablePerInvocation': {},
                        'overrideMinPrice': {},
                    }} data={data} metadata={type} />
                </DetailBox>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(BillingRuleView), (props) => {
    return props.user.organisation && props.user.organisation.billingRule;
}), {
    initialVariables: {
        organisationId: '',
        billingRuleId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    billingRule(id: $billingRuleId) {
                        organisation_id,
                        id,
                        billingNote,
                        validSince,
                        validTo,
                        overridePricePerInstance,
                        overridePricePerInstanceNext,
                        overridePricePerInvocation,
                        overrideTablePerInvocation,
                        overrideMinPrice,
                        flow_id,
                        flow {
                            id,
                            realId,
                            flowTitle,
                            name,
                        },
                        flowDef_id,
                        flowDef {
                            id,
                            name,
                        },
                    }
                }
            }
        `,
    },
});
